"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionsOperator = void 0;
// main
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * Describes whether listed countries/country subdivisions are included in an experience
 */
exports.RegionsOperator = (0, type_utils_1.makeEnum)({
    /** The listed countries/country subdivisions, time zones, and languages are included in this experience */
    In: 'IN',
    /** The listed countries/country subdivisions, time zones, and languages are NOT included in this experience */
    NotIn: 'NOT_IN',
});
//# sourceMappingURL=experience.js.map